var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV3Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.9903268%",
    y1: "155.518542%",
    x2: "50%",
    y2: "-1.04083409e-13%",
    id: "linearGradient-2e6cyvapzf-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45A90",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2e6cyvapzf-2",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    rx: 20
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.77635684e-13%",
    y1: "42.3540893%",
    x2: "47.7727725%",
    y2: "46.9538638%",
    id: "linearGradient-2e6cyvapzf-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.853553185%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-2e6cyvapzf-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updates-June-2022",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Home",
    transform: "translate(-113.000000, -165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(93.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "swiftfill",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#path-2e6cyvapzf-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-2e6cyvapzf-1)",
    xlinkHref: "#path-2e6cyvapzf-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(42.800000, 4.964223)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 16.864917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70839933,18.584789 C7.70839933,18.584789 10.0318453,19.42085 13.0590783,19.6019594 C16.493812,19.8073468 18.8899399,21.6056483 19.7110017,22.3167533 L19.846362,22.4366906 C19.9241224,22.5072827 19.9767485,22.55827 20.0031925,22.584418 L20.023091,22.6043561 C14.8624512,22.5337542 10.6997267,23.6313866 7.70839933,18.584789 Z M17.6776301,-3.55271368e-15 L30.3011355,11.7951996 L27.6457773,21.4802804 C27.6457773,21.4802804 27.6456694,21.4795047 27.645438,21.477968 L27.642445,21.4597331 C27.5763464,21.0798883 26.4212466,15.5378584 15.014401,13.5495535 C2.15534083,11.3079189 0,1.76036435 0,1.76036435 C8.3606216,3.75828702 17.6776301,-3.55271368e-15 17.6776301,-3.55271368e-15 L17.6776301,-3.55271368e-15 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-2e6cyvapzf-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1896616,2.9585752 C17.0150587,2.04107655 17.9528197,1.16862392 19.0232069,0.349087802 C19.5079958,-0.0235047326 20.1890448,0.000441663948 20.6463707,0.40602329 C22.2434112,1.8180234 24.1400327,2.80920327 26.4154428,3.26837124 C26.6761738,3.32078538 26.9439381,3.32882333 27.2073485,3.29181526 C28.1883134,3.15416535 30.8567458,2.77956333 32.4825889,2.551319 C32.7570515,2.51280382 33.0313465,2.62248836 33.2036601,2.8396805 C33.3759737,3.05687265 33.4201824,3.34908567 33.3202104,3.60763977 C32.8603726,4.79541453 32.1873617,6.53345404 31.8442416,7.42097783 C31.6985537,7.79758934 31.7675462,8.20534791 31.709271,8.60473362 C31.0215238,13.3285371 40.9664791,23.3460014 39.92322,25.5273004 C38.8797934,27.7085995 28.4008168,25.0512193 25.4490466,21.6925278 C24.9635878,21.1402536 24.3466751,20.5032459 23.6445265,19.8099726 C23.1578956,19.3295376 22.593062,18.7933393 22.1754235,18.3897671 C21.2125439,17.4737756 20.1684475,16.5016859 19.1265281,15.5247399 C17.8148349,14.2616093 17.4792504,13.9384167 15.1983143,11.741879 C14.5721914,11.108388 14.000827,10.5053742 13.5128564,9.95008572 C13.2767416,9.68148418 13.1104564,9.36951119 13.0166803,9.03962028 C13.1948549,5.80400996 14.5743683,6.05452611 16.1896616,2.9585752 Z",
    id: "SVGID_2_",
    fill: "url(#linearGradient-2e6cyvapzf-4)",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV3Logo);
export default __webpack_public_path__ + "static/media/v3-logo.de7476f8dab41eeb7a1c5cae369c3076.svg";
export { ForwardRef as ReactComponent };